<app-confirmation-dialog #confirmDeleteDialog (confirmed)="onDeleteShotConfirmed($event)"
(cancelled)="onDeleteShotCancelled()"></app-confirmation-dialog>
<app-confirmation-dialog #confirmSaveDialog (confirmed)="onSaveChangesConfirmed()"
(cancelled)="onSaveChangesCancelled()"></app-confirmation-dialog>
<app-confirmation-dialog #confirmInTheHoleDialog (confirmed)="onInTheHoleConfirmed()"
(cancelled)="onInTheHoleCancelled()"></app-confirmation-dialog>
@if (isVisible) {
  <div id="shotListModal">
    <div class="modal-content p-0">
      <!-- Player Name Header -->
      <div class="player-header">
        {{ params.playerName }}
      </div>
      <!-- Hole Info Header -->
      <div class="hole-header">
        Hole {{ params.score.holeNumber }} - Par {{ params.par }} -
        {{ params.score.holeYardage }} Yards
      </div>
      <div class="modal-body p-0 shot-table-body">
        <table class="table mb-0 shot-table">
          <tbody id="shot-list" cdkDropList (cdkDropListDropped)="drop($event)">
            @for (shot of shots; track shot; let i = $index) {
              <tr id="shot-row-{{ i }}" class="shot-row" cdkDrag>
                <!-- Drag Handle -->
                <td id="shot-drag-handle-{{ i }}" class="shot-drag-handle">
                  @if (shots.length > 1 && !isHoleComplete()) {
                    <span cdkDragHandle title="Drag to reorder"
                      style="cursor: grab; font-size: 1.5em; color: #888;">
                      &#9776;
                    </span>
                  }
                </td>
                <!-- Shot Number -->
                <td class="shot-number">
                  {{ shot.number }}
                </td>
                <!-- Shot Description and Time -->
                <td class="shot-desc text-left">
                  @if(isHoleComplete()){
                    <span class="shot-desc-complete">
                      {{ shot.shotFromName }}
                    </span>
                  } @else
                    {
                    <div id="shotFromDropdown-{{ i }}" class="dropdown shot-desc-main w-100">
                      <button #shotFromButton id="shotFromItemsButton-{{ i }}" data-toggle="dropdown"
                        class="btn btn-primary btn-outline dropdown-toggle w-100 text-left">
                        <strong>{{ shot.shotFromName }}</strong> <span class="caret"></span>
                      </button>
                      <ul id="shotFromItems-{{ i }}" class="dropdown-menu w-100">
                        @for (option of shotFromsAndTypes; track option) {
                          <li
                            (click)="selectShotFromOrType(shot, option); $event.preventDefault()" class="dropdown-item"
                            style="display: flex; width: 194px;">
                    <a id="shotFromItem-{{ i }}" class="dropdown-item" href="#" style="
                        display: flex;
                        width: 100%;
                        align-items: center;
                        font-weight: bold;
                      ">
                              <span>{{ option.name }}</span>
                            </a>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  <div class="shot-time">
                    {{ shot.submittedAt | date : "h:mm:ss a" }}
                  </div>
                </td>
                <!-- Delete Icon if a Normal shot -->
                <td class="shot-action">
                  @if(shots.length > 1 && !isHoleComplete()) {
                    <button id="deleteShotButton-{{ i }}" [disabled]="" class="btn btn-link btn-sm text-danger px-2"
                      (click)="deleteShot(shot)">
                      <i class="fa fa-minus-circle" style="font-size: 2em;"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="modal-actions-row">
        @if (isHoleComplete()) {
          <div class="hole-completed">
            <div id="holeCompletedAlert" class="alert alert-success d-flex justify-content-center align-items-center">
              <span class="hole-completed-text">Hole Completed</span>
              <button id="holeCompletedButton" type="button" class="btn-close" aria-label="Close"
                (click)="markIncomplete()">
                <i class="fa fa-times-circle"></i>
              </button>
            </div>
          </div>
        }
        <div class="shot-list-actions">
          <button id="backButton" [disabled]="!canBack()" (click)="handleBackClick()" type="button"
          class="btn btn-primary">BACK</button>
          <button id="markInTheHole" [disabled]="isHoleComplete() || isAddingShot() || hasNoShots()"
            (click)="markInTheHole()" type="button" class="btn btn-primary">IN THE
          HOLE</button>
          <button id="tapInButton" [disabled]="isHoleComplete() || isAddingShot()" (click)="tapIn()" type="button"
          class="btn btn-primary">TAP IN</button>
          <button id="addShotButton" [disabled]="isHoleComplete() || isAddingShot()" (click)="addShot()" type="button"
            class="btn btn-primary">ADD
          SHOT</button>
        </div>
        <div class="shot-list-stats">
          <div class="stat">
            <span class="stat-label">FWY</span>
            <div class="stat-value">
              @if (!isPar3) {
                @if (fwys) {
                  <i class="fa fa-check-circle stat-true"></i>
                }
                @if (!fwys) {
                  <i class="fa fa-times-circle stat-false"></i>
                }
              }
            </div>
          </div>
          <div class="stat">
            <span class="stat-label">GIR</span>
            <div class="stat-value">
              @if (gir) {
                <i class="fa fa-check-circle stat-true"></i>
              }
              @if (!gir) {
                <i class="fa fa-times-circle stat-false"></i>
              }
            </div>
          </div>
          <div class="stat">
            <span class="stat-label">SS</span>
            <div class="stat-value">
              @if (ss) {
                <i class="fa fa-check-circle stat-true"></i>
              }
              @if (!ss) {
                <i class="fa fa-times-circle stat-false"></i>
              }
            </div>
          </div>
          <div class="stat">
            <span class="stat-label">PUTTS</span>
            <div class="stat-value">{{ displayPutts }}</div>
          </div>
          <div id="stat-score" class="stat">
            <span class="stat-label">SCORE</span>
            <div class="stat-value">{{ displayScore }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
}